import React, { useState } from 'react'
import renderImage from '../../../source/importImg'
import renderPrgImage from '../../../source/programImg'
import DeviceSelectStyle from '../../Login/DeviceSelect.module.css'
import AssemblyPrgm from '../PrgmSlider/AssemblyPrgm/AssemblyPrgm'
import LogicPrgm from '../PrgmSlider/LogicPrgm/LogicPrgm'

/**
 * useHeaderHelp
 * -------------------------------------------------
 * Owns the three help toggles used by the header
 * (assembly slide, hex/logic slide, connectivity overlay).
 */
export function useHeaderHelp() {
    const [isAssemblyHelp, setAssemblyHelp] = useState(false)
    const [isHexHelp, setHexHelp] = useState(false)
    const [isConnectivityHelp, setConnectivityHelp] = useState(false)

    return {
        isAssemblyHelp,
        toggleAssemblyHelp: () => setAssemblyHelp((v) => !v),
        isHexHelp,
        toggleHexHelp: () => setHexHelp((v) => !v),
        isConnectivityHelp,
        toggleConnectivityHelp: () => setConnectivityHelp((v) => !v),
    }
}

/**
 * HelpSlideModals
 * -------------------------------------------------
 * The assembly / hex help slide-in panels rendered at the top of
 * the header (inside the navbar container).
 */
export function HelpSlideModals({
    isAssemblyHelp,
    toggleAssemblyHelp,
    isHexHelp,
    toggleHexHelp,
    zIndex = '10000',
}) {
    return (
        <div className="navbarContainer" style={{ zIndex }}>
            <div className="navbar-Action" style={{ alignItems: 'center' }}>
                {/* Assembly Help Modal */}
                {isAssemblyHelp && (
                    <div
                        className="Ss_slide"
                        style={{
                            width: '106vw',
                            top: '49vh',
                            left: '-55%',
                            height: '105vh',
                        }}
                    >
                        <AssemblyPrgm />
                        <img
                            className="helpClo"
                            src={renderPrgImage('closBtn')}
                            onClick={toggleAssemblyHelp}
                        ></img>
                    </div>
                )}

                {/* Hex Help Modal */}
                {isHexHelp && (
                    <div
                        className="Ss_slide"
                        style={{
                            bottom: '10%',
                            left: '-55%',
                            zIndex: '10000000',
                        }}
                    >
                        <LogicPrgm />
                        <img
                            className="helpClo"
                            src={renderPrgImage('closBtn')}
                            onClick={toggleHexHelp}
                        ></img>
                    </div>
                )}
            </div>
        </div>
    )
}

/**
 * ConnectivityHelpOverlay
 * -------------------------------------------------
 * Full-screen device-connectivity tutorial overlay.
 */
export function ConnectivityHelpOverlay({ onClose }) {
    return (
        <div
            style={{
                inset: 0,
                background: '#fff',
                zIndex: 5000,
                position: 'fixed',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {/* Close Button for Overlay */}
            <img
                className={DeviceSelectStyle.Cross}
                style={{
                    position: 'absolute',
                    top: '160px',
                    right: '20px',
                    zIndex: 5001,
                    cursor: 'pointer',
                    width: '40px',
                }}
                src={renderImage('clos')}
                onClick={onClose}
                alt="Close"
            />

            <div style={{ width: '65vw', position: 'relative' }}>
                <div>
                    <img
                        src={
                            sessionStorage.getItem('connectedDevice') ===
                            'Humanoid'
                                ? renderImage('ZingConnect')
                                : renderImage('Connect')
                        }
                        style={{ width: '100%' }}
                        alt="Connection Tutorial"
                    />
                </div>

                <div className={DeviceSelectStyle.instr}>
                    <p className={DeviceSelectStyle.instr_P}>
                        Help Button will explain all the features and
                        functionality of the entire app for each screen.
                    </p>
                </div>
                <div className={DeviceSelectStyle.instr2}>
                    <p className={DeviceSelectStyle.instr2_P}>
                        Manual scan will list all the Playcomputer devices if
                        multiple devices are ON.
                    </p>
                </div>
                <div className={DeviceSelectStyle.instr3}>
                    <p className={DeviceSelectStyle.instr3_P}>
                        Skip button will skip the scanning and connecting over
                        bluetooth. If you skip, you will not be able to send
                        data.
                    </p>
                </div>
            </div>
        </div>
    )
}
